import React from 'react';
import Reflux from 'reflux';

import { Grid, Row } from 'bootstrap';
import CueTableList from 'main/components/show/cuesheet.responsive/cueTableList.jsx';
import CueList from 'main/components/show/cuesheet.responsive/cueList.jsx';
import CueDetail from 'main/components/show/cuesheet.responsive/cueDetail.jsx';

import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import { ResponsiveDisplayModes } from 'flux/stores/cuesheet/CuesheetConstants';

import ItemDataCellModal from 'main/components/show/cuesheet.responsive/itemDataCellModal.jsx';
import ItemDurationModal from 'main/components/show/cuesheet.responsive/itemDurationModal.jsx';
import ItemPresetDurationModal from 'main/components/show/cuesheet.responsive/itemPresetDurationModal.jsx';
import ItemStartTimeModal from 'main/components/show/cuesheet.responsive/itemStartTimeModal.jsx';
import ItemNumberModal from 'main/components/show/cuesheet.responsive/itemNumberModal.jsx';
import ItemTitleModal from 'main/components/show/cuesheet.responsive/itemTitleModal.jsx';
import ItemDescriptionModal from 'main/components/show/cuesheet.responsive/itemDescriptionModal.jsx';
import ItemNoteModal from 'main/components/show/cuesheet.responsive/itemNoteModal.jsx';
import CueMenuModal from 'main/components/show/cuesheet.responsive/cueMenuModal.jsx';
import ColumnConfigModal from 'main/components/show/cuesheet.responsive/columnConfigModal.jsx';
import HotKeyMixin from 'main/components/show/cuesheet/hotKeyMixin';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin.js';
import CuesheetPopulateMixin from 'main/components/show/cuesheet/cuesheetPopulateMixin.js';

export default React.createClass({
  displayName: 'ShowCuesheet',

  mixins: [
    Reflux.connectFilter(CuesheetResponsiveStore, 'displayMode', (state) =>
      state.get('displayMode'),
    ),
    Reflux.ListenerMixin,
    HotKeyMixin,
    CuesheetMixin,
    CuesheetPopulateMixin,
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <Grid fluid className="csr-cuesheet">
        <Row>
          {this._getCuesheetNode()}

          <ItemStartTimeModal />
          <ItemPresetDurationModal />
          <ItemDurationModal />
          <ItemNumberModal />
          <ItemTitleModal />
          <ItemDescriptionModal />
          <ItemNoteModal />
          <ItemDataCellModal />
          <CueMenuModal />
          <ColumnConfigModal />
        </Row>
      </Grid>
    );
  },

  _getCuesheetNode() {
    if (this._getDisplayMode() === ResponsiveDisplayModes.Table.toLowerCase()) {
      return (
        <div className="csr-cuesheet-table">
          <CueTableList />
        </div>
      );
    }

    return (
      <div className="csr-cuesheet-shotgun">
        <CueList />
        <CueDetail />
      </div>
    );
  },

  _getDisplayMode() {
    let { params } = this.context.router.state;

    return params.displayMode || 'shotgun';
  },
});
